import { Button, Modal, Form, Input, Row, Col, message } from "antd";
import API from "../../../services/api-request";

const AddClients = (props) => {
  const [addForm] = Form.useForm();

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = async (values) => {
    const { name, address } = values;

    const dataForm = {
      name,
      address,
    };

    await API.Post("client/create", dataForm)
      .then(() => {
        message.success("Client has been added");
        addForm.resetFields();
        props.onShowAdd(false);
        props.onGetClients();
      })
      .catch((err) => {
        console.error(err);
        if (!err.response.data) {
          message.info("Failed add client");
        }

        message.info(
          `${err.response.data.errors[0].path} ${err.response.data.errors[0].msg}`
        );
      });
  };

  const handleCancel = () => {
    props.onShowAdd(false);
    addForm.resetFields();
  };

  return (
    <>
      <Modal
        title="Add Client"
        open={props.showAdd}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => addForm.submit()}>
            Submit
          </Button>,
        ]}
      >
        <Form
          form={addForm}
          name="Add Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Name"
                name="name"
                rules={[{ required: true, message: "Please input your name!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Address"
                name="address"
                rules={[
                  { required: true, message: "Please input your address!" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default AddClients;
